import React from 'react';

const ErrorMessage = ({ message }) => (
  <div className="mb-4 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded-lg">
    <p>{message}</p>
  </div>
);

export default ErrorMessage;